export enum eConfigTable {
    Page = 1,
    PageSize = 50
}
export enum SystemOptions {
    MinWidth = 768
    // MinWidth = 1080
}

export enum ePathStorage {
    Business = "businesses/logos",
    GroupBusiness = "business_groups/logos",
    LendingDocuments = "lendings/documents",
    Comerces = "commerces",
    Promotions = "promotions",
    Courses = "course_image",
    Raffles = "raffles"
}

export enum eTypeUser {
    Collaborator = 1,
    AdminBusiness = 2,
    AdminIpay = 3,
    SistemIpay = 4
}

export enum eKeyLocalStorage {
    DataUser = "companyUserData",
    BusinessSelected = "selectedManagedBusinessId",
    RememberedEmail = "rememberedEmail",
}

export enum eKeyFilterCache {
    Collaborator = "collaborators",
    AdminBusiness = "admin-businesses",
    AdminIpay = "admin-ipay",

    LiquidationsIpayAdmin = "liquidations-ipay-admin",
    LiquidationsBusiness = "liquidations-business",

    Business = "businesses",
    GroupBusiness = "group-businesses",
    SuscriptionsPrice = "suscriptions-price",

    Lending = "lendings",
    Disbursements = "disbursements",

    LendingRequests = "lending-requests",
    AmortizationRequests = "amortization-requests",
    CollaboratorDischarge = "collaborator-discharge",

    RecaudationBusiness = "recaudation-business",//RecaudationBusinessComponent
    RecaudationViewBusiness = "recaudation-view-business",
    RecaudationViewCollaborators = "recaudation-view-collaborators",//RecaudationCollaboratorsComponent
    RecaudationViewBusinessPeriod = "recaudation-view-business-period",//RecaudationBusinessPeriodComponent

    Commerce = "commerces",
    Promotions = "promotions",
    Courses = "courses",

    TransactionsBusiness = "transactions-business",
    Facturation = "facturation",

    NotificationTemplate = "notification-template",

    Raffles = "raffles",
    ListTransactionsBusinesss = "list-transactions-business",

    Banks = "banks",
    BanksAccount = "banks-account",
    Currencies = "currency",
    Countries = "countries",
    CardTypes = "card-types",
    BusinessCategories = "business-categories",
    PayrollSoftware = "payroll-software",
    EmployeeReasons = "employee-reasons",
    CommerceCategories = "commerce-categories",
    CourseCategories = "courses-categories",
}

export enum eMenuOptions {
    LendingsRequest = 17,
    LendingsLiquidation = 19,
    RequestUserInactivation = 20
}